import { PayoutMethods } from './constants';

export const getFrequencyDisplayName = (frequency, { t }) => t(`sauron.financeModule.payoutProfiles.frequencies.${frequency}`);

export const getPayoutMethod = payoutProfile => {
    return payoutProfile.payout_threshold !== 0 ? PayoutMethods.PAYOUT_THRESHOLD : PayoutMethods.FREQUENCY;
};
